module.exports = __webpack_public_path__ + "img/l-09.d3c89db8.png";